const QR_REDIRECT_BASE = "https://roboticimaging.ai/redirect";

/**
 * Builds a QR code image URL from the asset's redirect code.
 * The physical QR encodes `https://roboticimaging.ai/redirect/{code}`.
 * We render the image via the qrserver.com API.
 */
export function getQrCodeImageUrl(qrCodeId: string | null | undefined): string | null {
  if (!qrCodeId) return null;
  const redirectUrl = `${QR_REDIRECT_BASE}/${qrCodeId}`;
  return `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(redirectUrl)}`;
}
